import ROUTER_TYPE from '@/router/routeType'

// メニュー種別定義
const MENU_TYPE = {
  DOWNLOAD: 'download', // ダウンロード画面
  PASSWORD_UPDATE: 'password', // パスワード画面
} as const
type MENU_TYPE = typeof MENU_TYPE[keyof typeof MENU_TYPE]

// メニュー画面情報
type MENU_INFO = {
  // メニュー種別
  name: MENU_TYPE
  // routeの名前
  routerName: string
  // 画面表示キー
  resourcekey: string
}

// メニュー一覧定義
const MENU_LIST: Array<MENU_INFO> = [
  // ダウンロード画面
  {
    name: MENU_TYPE.DOWNLOAD,
    routerName: ROUTER_TYPE.DOWNLOAD.path,
    resourcekey: 'body.menu.download.title',
  },
  // パスワード変更画面
  {
    name: MENU_TYPE.PASSWORD_UPDATE,
    routerName: ROUTER_TYPE.USER_EDIT_PASS.path,
    resourcekey: 'body.menu.password.title',
  },
]

export { MENU_LIST, MENU_TYPE }
